import React from "react";
var __jsx = React.createElement;
import stl from './ContactUsNew.module.css';
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
var ContactUsNew = function ContactUsNew(_ref) {
  var phoneNumber = _ref.phoneNumber,
    _ref$showReturn = _ref.showReturn,
    showReturn = _ref$showReturn === void 0 ? false : _ref$showReturn,
    onClickReturn = _ref.onClickReturn;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.contactUsOptions
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.headerDesktop].join(" ")
  }, /*#__PURE__*/React.createElement("h4", {
    className: stl.title
  }, t("questions", {
    ns: "web_tracking"
  }))), /*#__PURE__*/React.createElement("a", {
    className: stl.call,
    href: "tel:" + phoneNumber
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/CallTM.svg",
    alt: "phone"
  }), /*#__PURE__*/React.createElement("p", {
    className: stl.text
  }, t("contact", {
    ns: "web_tracking"
  }))), /*#__PURE__*/React.createElement("a", {
    className: stl.whats,
    href: "https://wa.me/+966" + phoneNumber
  }, /*#__PURE__*/React.createElement("img", {
    width: "20px",
    src: CDN_LINK + "/assets/images/whTM.svg",
    alt: "call"
  }), /*#__PURE__*/React.createElement("p", {
    className: stl.text
  }, t("contact_via_whatsapp", {
    ns: "web_tracking"
  }))), showReturn && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.returnButton,
    onClick: onClickReturn
  }, t("submit_car_return_request", {
    ns: "web_tracking"
  })))));
};
export default ContactUsNew;